const v = (value) =>
  value === null || value === undefined || value === "" ? "-" : value;

export const ZAEXCommercialTerms = (terms = {}) => {
  const rawItems = [
    ["Agreed Credit Days", v(terms.AgreedCreditDays)],
    ["Lead Time", v(terms.LeadTime)],
    ["In Days (SOR)", v(terms.InDaysSOR)],
    ["In Favour Of", v(terms.InFavourOf)],
    ["Payment Method", v(terms.PaymentMethod)],
    ["Bank Name", v(terms.BankName)],
    ["Branch Name", v(terms.BranchName)],
    ["Account Number", v(terms.AccountNo)],
    ["IFSC Code", v(terms.IFSCCode)],
  ];

  const rows = [];
  for (let i = 0; i < rawItems.length; i += 2) {
    rows.push(rawItems.slice(i, i + 2));
  }

  return `
<h5>Commercial Terms</h5>

<style>
  .commercial-table {
    width: 100%;
    border-collapse: collapse;
    page-break-inside: auto;
  }
  .commercial-table tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .commercial-table td {
    border: 1px solid #000;
    padding: 6px;
    vertical-align: top;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .commercial-table td div {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .lbl {
    font-weight: 600;
    white-space: nowrap;
  }
</style>

<table class="commercial-table">
  ${
    rows.length === 0
      ? `<tr><td colspan="4" style="text-align:center;">No Commercial Terms Available</td></tr>`
      : rows
          .map(
            (row) => `
            <tr>
              ${row
                .map(
                  ([label, value]) => `
                    <td class="lbl"><div>${label}</div></td>
                    <td><div>${value}</div></td>
                  `
                )
                .join("")}
            </tr>
          `
          )
          .join("")
  }
</table>
`;
};